export interface PracticeWord {
  letter: string;
  pronunciationVi: string;
}

export const practiceData = {
  consonants: [
    { letter: 'ກ', pronunciationVi: 'co' },
    { letter: 'ຂ', pronunciationVi: 'khỏ' },
    { letter: 'ຄ', pronunciationVi: 'kho' },
    { letter: 'ງ', pronunciationVi: 'ngo' },
    { letter: 'ຈ', pronunciationVi: 'cho' },
    { letter: 'ສ', pronunciationVi: 'sỏ' },
    { letter: 'ຊ', pronunciationVi: 'xo' },
    { letter: 'ຍ', pronunciationVi: 'nho' },
    { letter: 'ດ', pronunciationVi: 'đo' },
    { letter: 'ຕ', pronunciationVi: 'to' },
    { letter: 'ຖ', pronunciationVi: 'thỏ' },
    { letter: 'ທ', pronunciationVi: 'tho' },
    { letter: 'ນ', pronunciationVi: 'no' },
    { letter: 'ບ', pronunciationVi: 'bo' },
    { letter: 'ປ', pronunciationVi: 'po' },
    { letter: 'ຜ', pronunciationVi: 'phỏ' },
    { letter: 'ຝ', pronunciationVi: 'fỏ' },
    { letter: 'ພ', pronunciationVi: 'pho' },
    { letter: 'ຟ', pronunciationVi: 'fo' },
    { letter: 'ມ', pronunciationVi: 'mo' },
    { letter: 'ຢ', pronunciationVi: 'do' },
    { letter: 'ຣ', pronunciationVi: 'ro' },
    { letter: 'ລ', pronunciationVi: 'lo' },
    { letter: 'ວ', pronunciationVi: 'vo' },
    { letter: 'ຫ', pronunciationVi: 'hỏ' },
    { letter: 'ອ', pronunciationVi: 'o' },
    { letter: 'ຮ', pronunciationVi: 'ho' },
    { letter: 'ຫງ', pronunciationVi: 'ngỏ' },
    { letter: 'ຫຍ', pronunciationVi: 'nhỏ' },
    { letter: 'ຫມ', pronunciationVi: 'mỏ' },
    { letter: 'ຫນ', pronunciationVi: 'nỏ' },
    { letter: 'ຫລ', pronunciationVi: 'lỏ' },
    { letter: 'ຫວ', pronunciationVi: 'vỏ' },
  ]
}; 